import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleObjectSelection,
  getSelectedObjects,
  getSelectionCount,
} from "../../redux/objectSelection";
import { getBaseWindow, getWindowPolygonYUp } from "../sensorAnalysis/utils";
import { isResourceInState } from "../../redux/sensorAnalysis";
import { resources } from "../../redux/sensorAnalysisConstants";

export const useWindowSelection = (windows) => {
  const dispatch = useDispatch();

  const selectedObjects = useSelector((state) => getSelectedObjects(state));
  const selectionCount = useSelector((state) => getSelectionCount(state));

  const sensoranalysisState = useSelector(
    (state) => state.sensorAnalysis.sensorAnalysisState
  );
  const isSelectionActive = isResourceInState(
    sensoranalysisState,
    resources.SELECTABLE_WINDOWS
  );

  const allWindows = useSelector((state) => state.windowData.allWindows);

  const handleObjectClick = useCallback(
    (objectId, event) => {
      if (!isSelectionActive) return false;

      event?.stopPropagation?.();
      dispatch(toggleObjectSelection({ objectId }));

      return true;
    },
    [isSelectionActive, dispatch]
  );

  const getSelectedObjectsData = useCallback(() => {
    return (windows ?? allWindows ?? []).filter((obj) =>
      selectedObjects.includes(obj.id)
    );
  }, [allWindows, selectedObjects, windows]);

  const selectedWindowsData = useMemo(() => {
    return getSelectedObjectsData();
  }, [getSelectedObjectsData]);

  const selectedWindow = useMemo(
    () => getBaseWindow(selectedWindowsData),
    [selectedWindowsData]
  );

  const selectedPolygonYUp = useMemo(() => {
    return getWindowPolygonYUp(selectedWindow);
  }, [selectedWindow]);

  return {
    selectionCount,
    handleObjectClick,
    selectedWindowsData,
    selectedWindow,
    selectedPolygonYUp,
    selectedObjects,
  };
};

export default useWindowSelection;
